module.exports = __webpack_public_path__ + "static/media/Centrifuge_Rotor_Adapters.8e78abef.svg";